import React from 'react'

import { useAppConfig } from '../../api/useAppConfig'

type AppConfigResult = {
  config: {
    version?: string
  } | null
  loading: boolean
  error: string | null
}

function DesktopAppVersion() {
  const { config, loading, error } = useAppConfig() as AppConfigResult

  if (loading || error || !config?.version) return null

  return (
    <div className="text-center text-xs text-[#999]">v{config.version}</div>
  )
}

export default DesktopAppVersion
